import {ListPromocodes} from './list-promocodes';

export default ListPromocodes;